import { BaseLookup } from "./BaseLookup";

export class Category extends BaseLookup {
    sportId: string;
    sortOrder: number;
}